import { exhaustive } from "exhaustive"
import type { DisplayContext, MergedGroup, RenderMode } from "../events/messageGroups"

export function getRenderMode(group: MergedGroup, ctx: DisplayContext): RenderMode {
    return exhaustive.tag(group, "type", {
        text: () => "inline",
        thinking: () => "pill",
        tool: () => "pill",
        edit: () => "row",
        write: () => "row",
        fileChange: () => "row",
        bash: () => "pill",
        orchestration: () => "pill",
        system: () => "pill",
        result: () => "pill",
        stderr: () => "pill",
        unknown: () => "pill",
        activity: () => "pill",
        providerNotice: (notice) => (notice.kind === "goal" || notice.kind === "recap" ? "row" : "pill"),
        agentActivity: () => "row",
        todoWrite: () => (ctx.isLatestTodoGroup ? "row" : "pill"),
    })
}
